import { Component, Mixins } from 'vue-property-decorator';
import { EventBus } from '@/services/event-bus';

declare module 'vue/types/vue' {
    interface Vue {
        $bus: Vue;
    }
}

@Component
export default class EventBusMixin extends Mixins() {
    get $bus() {
        return EventBus
    }
}
